"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemIcon.default;
  }
});

var _ListItemIcon = _interopRequireDefault(require("./ListItemIcon"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ListItemIcon/index.js
// module id = 525
// module chunks = 0